"use strict";

if (!customElements.get("sqli-recommended-products")) {
  class SqliRecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.columns = parseInt(this.getAttribute("data-columns"), 10);
      this.init();
    }

    init() {
          const productCards = this.querySelectorAll("product-card");
          productCards.forEach((product) => {
            const slider = product.closest("carousel-slider .grid-carousel");
            const productId = product.dataset.productId;


            product.querySelector(".card-footer")?.append?.(textElement);
            if (slider) {
              const flickity = Flickity.data(slider);
              flickity?.resize();
              this.sliderNav = this.querySelector("carousel-navigation");

              if (productCards.length <= this.columns) {
                this.sliderNav ? (this.sliderNav.style.display = "none") : null;
              }
            }
          });
    }
  }

  customElements.define("sqli-recommended-products", SqliRecommendedProducts);
}
